/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a fixed deposit better than a SIP?`)
};

const es_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Un depósito fijo es mejor que un SIP?`)
};

const de_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ein Festgeld besser als ein SIP?`)
};

const nl_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een vaste storting beter dan een SIP?`)
};

const fr_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un placement à terme fixe est-il meilleur qu'un SIP ?`)
};

const it_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un deposito fisso è meglio di un SIP?`)
};

const pt_br2_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um depósito fixo é melhor que um SIP?`)
};

const pt_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um depósito fixo é melhor que um SIP?`)
};

const ja_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期預金はSIPより良いですか？`)
};

const zh_sip_fd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定期存款是否好于SIP？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_fd_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_fd_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_fd_faq4_q", locale)
	if (locale === "en") return en_sip_fd_faq4_q(inputs)
	if (locale === "es") return es_sip_fd_faq4_q(inputs)
	if (locale === "de") return de_sip_fd_faq4_q(inputs)
	if (locale === "nl") return nl_sip_fd_faq4_q(inputs)
	if (locale === "fr") return fr_sip_fd_faq4_q(inputs)
	if (locale === "it") return it_sip_fd_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_sip_fd_faq4_q(inputs)
	if (locale === "pt") return pt_sip_fd_faq4_q(inputs)
	if (locale === "ja") return ja_sip_fd_faq4_q(inputs)
	return zh_sip_fd_faq4_q(inputs)
};